import { render, staticRenderFns } from "./Hero.vue?vue&type=template&id=0bd3022e&scoped=true&"
var script = {}
import style0 from "./Hero.vue?vue&type=style&index=0&id=0bd3022e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd3022e",
  null
  
)

export default component.exports